import { jsxs as i, jsx as d } from "react/jsx-runtime";
import { tv as n } from "tailwind-variants";
const s = n({
  slots: {
    base: ["font-secondary", "font-semibold"],
    required: "text-rose-600"
  },
  variants: {
    isHidden: {
      true: {
        base: "sr-only"
      }
    }
  }
}), { base: c, required: m } = s(), e = ({ children: a, className: r, htmlFor: t, isHidden: l, isRequired: o }) => /* @__PURE__ */ i("label", { className: c({ class: r, isHidden: l }), htmlFor: t, children: [
  a,
  o && /* @__PURE__ */ d("sup", { "aria-hidden": "true", className: m(), children: "*" })
] });
e.displayName = "Label";
e.styles = s;
export {
  e as default
};
